import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const HeartIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.52065 3.11077C4.09475 1.52328 6.49643 1.98346 8 3.49982C9.50357 1.98346 11.9052 1.52328 13.4793 3.11077C14.9478 4.5918 14.7282 6.64041 13.4793 8.47405C12.2304 10.3077 7.99998 14 7.99998 14C7.99998 14 3.76942 10.3077 2.52065 8.47405C1.27188 6.64041 1.05212 4.5918 2.52065 3.11077Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
));
